import { arrayToDistinct } from "@opendash/core";
import Parse, { Role, User } from "parse";
import { _Role } from "../../../js/parsegenerated";

export async function fetchAllRolesWithSubordinates(user: User) {
  const userQuery = new Parse.Query(User).equalTo("objectId", user.id);
  const allUserRoles = await new Parse.Query(Role)
    .matchesQuery("users", userQuery)
    .include("roles")
    .find();

  const allRoles: Role[] = [];
  for (const userRole of allUserRoles) {
    allRoles.push(userRole);
    const childRoles: Role[] = await fetchChildRoles(userRole as _Role);
    allRoles.push(...childRoles);
  }

  const distinctRoles = arrayToDistinct(allRoles, (role) => role.id);
  return distinctRoles;
}

async function fetchChildRoles(role: _Role) {
  const childRoles: Role[] = await role.get("roles").query().find();
  for (const childRole of childRoles) {
    const grandChildRoles: Role[] = await fetchChildRoles(childRole as _Role);
    childRoles.push(...grandChildRoles);
  }
  return childRoles;
}
